module.exports = __webpack_public_path__ + "img/symbol_5.9b35ac4f.png";